﻿import { InternalAxiosRequestConfig } from 'axios';

const authorization = 'Authorization';
const bearer = 'Bearer';

const AuthInterceptor = {
    async request(request: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> {
        if (window.config?.commonLibraryApiUrl === undefined) {
            throw new Error('Cannot check request configuration');
        }

        if (request.url?.startsWith(window.config.commonLibraryApiUrl)) {
            const accessToken = await window.authService.acquireToken();
            request.headers[authorization] = `${bearer} ${accessToken}`;
            return request;
        } else {
            return request;
        }
    }
};

export default AuthInterceptor;
